import { render, staticRenderFns } from "./user-dashboard.html?vue&type=template&id=ac9637c0&"
import script from "./user-dashboard.js?vue&type=script&lang=js&"
export * from "./user-dashboard.js?vue&type=script&lang=js&"
import style0 from "./user-dashboard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports